import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.clientes.rubros.create}
                buttonTitle={"Nuevo Rubro"}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Rubro ha sido creado con éxito."}
                title={"Nuevo Rubro"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                saveButton={true}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/clientes/Rubros/Create.js